import React from "react";
import { AppLayout } from "@project/components/AppLayout";
import { Outlet } from "react-router-dom";

/**
 * A wrapper component that provides the Hireflow (ATS) layout structure
 * around its children.
 */
const ATSLayoutWrapper: React.FC = () => {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};

export default ATSLayoutWrapper;
